import React, { Component } from 'react';
import { Modal, Button, Spin, Icon, Table, InputNumber, Row, Col, Tooltip, Input, Select, DatePicker  } from 'antd';
import { openNotification } from '../../util/notificaciones';
import PedidosRequest       from '../../services/Pedidos';
import { sanitizerTexto }   from '../../util/utilerias';
import { dayFechaEntrega,timerBloqueo } from "../../constants";
import './GenerarPedido.css'

import moment from 'moment'
import 'moment/locale/es';
import ResponsiveCard from '../Common/ResponsiveCard';
moment.locale('es')

const { confirm } = Modal;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
// const { RangePicker } = DatePicker;

document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de generar pedido
 */
export default class GenerarPedido extends Component {
    state = {
        arrCategorias: [],
        categoriaSelected: null,
        categoriaSelectedName: null,
        disableBtnContinuar: true,
        cargando: false,
        arrArticulosPedido: this.props.arrArticulosPedido ? this.props.arrArticulosPedido.map(articulo => ({
            ...articulo,
            cantidad_anterior: articulo.cantidad || 0,  
        })) : [],  
        arrArticulosPedidoCopy: this.props.arrArticulosPedidoCopy ? this.props.arrArticulosPedidoCopy.map(articulo => ({
            ...articulo,
            cantidad_anterior: articulo.cantidad || 0,  
        })) : [],  
        filterText: "",
        bloquearBotones: false,
        drivesSelected: null,
        arrDrives: [],
        bloquearGenerar: false,
        scroll: { x: 840, y: 500 },
        columnasOcultables: [
            { id: 0, descripcion: 'Pedidos en tránsito' },
            { id: 1, descripcion: 'Cantidad en pedidos' },
            { id: 2, descripcion: 'Existencia' },
            { id: 3, descripcion: 'Venta prom. diaria' },
            { id: 4, descripcion: 'Existencia en días' },
            { id: 5, descripcion: 'Pres. de UDC' },
        ],
        columnasOcultablesSelected: [2, 3, 4],
        showPedidosTransito: false,
        showCantidadPedidos: false,
        showExistencia: true,
        showVentaDiaria: true,
        showExistenciaDias: true,
        showPresentacionUDC: false,
        showModalConfirm: false,
        minDate: null,
        fechaEntrega: null,
        fechaEntregaVisible: false,
        tableMeasures: {
            codigoWidth: 110,
            nombreWidth: 220,
            udcWidth: 110,
            sugeridoWidth: 130,
            pedidoRealWidth: 130,
            diferenciaWidth: 100,
            cantidadEnPedidosWidth: 90,
            existenciaWidth: 115,
            ventaPromediaDiariaWidth: 140,
            existenciaEnDiasWidth: 140,
            presDeUdc: 120,
            inputSize: "default",
        },
        tableSources: {
            nombre: "descripcion_udm",
        },
        tableTitles: {
            nombre: "Nombre + Pieza"
        },
        procesado: false,
        showModalSalir: false,
    };

    componentWillMount = () => {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }

    onResize = () => {
        let state = {...this.state};
        let width = window.innerWidth;

        if (width <= 800) {
            state.tableMeasures.codigoWidth = 90;
            state.tableMeasures.nombreWidth = 220;
            state.tableMeasures.udcWidth = 90;
            state.tableMeasures.sugeridoWidth = 70;
            state.tableMeasures.pedidoRealWidth = 130;
            state.tableMeasures.diferenciaWidth = 70;
            state.tableMeasures.cantidadEnPedidosWidth = 70;
            state.tableMeasures.existenciaWidth = 70;
            state.tableMeasures.ventaPromediaDiariaWidth = 70;
            state.tableMeasures.existenciaEnDiasWidth = 70;
            state.tableMeasures.presDeUdc = 70;
            state.tableMeasures.inputSize = "small";
            state.scroll.x = 'auto';
            state.tableSources.nombre = "descripcion"
            state.tableTitles.nombre = "Nombre"
        } else {
            state.tableMeasures.codigoWidth = 110;
            state.tableMeasures.nombreWidth = width <= 1024 ? 220 : 440;
            state.tableMeasures.udcWidth = 110;
            state.tableMeasures.sugeridoWidth = 130;
            state.tableMeasures.pedidoRealWidth = 130;
            state.tableMeasures.diferenciaWidth = 130;
            state.tableMeasures.cantidadEnPedidosWidth = 90;
            state.tableMeasures.existenciaWidth = 115;
            state.tableMeasures.ventaPromediaDiariaWidth = 140;
            state.tableMeasures.existenciaEnDiasWidth = 140;
            state.tableMeasures.presDeUdc = 120;
            state.tableMeasures.inputSize = "default";
            state.tableSources.nombre = "descripcion_udm"
            state.tableTitles.nombre = "Nombre + Pieza"
        }

        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        let rol = localStorage.getItem("role");
        let rol_supervisor = rol === "Supervisor de Operaciones Drive" ? true : false;

        const bloqueado = localStorage.getItem("bloquearGenerar") === "true";
        const procesado = localStorage.getItem("procesado") === "true";
        
        this.setState({ bloquearGenerar: bloqueado, procesado });

        window.addEventListener("beforeunload", this.handleBeforeUnload);

        if (localStorage.getItem("pedidoEnProceso") === "true") {
            // Redirigimos a la página anterior
            const previousPath = localStorage.getItem("previousPath");
            if (previousPath)
            {
                this.props.history.push(previousPath);
                localStorage.removeItem("bloquearGenerar");
                localStorage.removeItem("procesado");
                localStorage.removeItem("previousPath");
                localStorage.removeItem("pedidoEnProceso");
                return;
            } else {
                this.props.history.goBack();
                localStorage.removeItem("bloquearGenerar");
                localStorage.removeItem("procesado");
                localStorage.removeItem("previousPath");
                localStorage.removeItem("pedidoEnProceso");
                return;
            }
        }

        if (this.props.location.state.categoria_id === 3 || this.props.location.state.categoria_id === 2)
        {
            //se agrega 1 día a la fecha de entrega
            this.minDate = moment().add(dayFechaEntrega, 'days').utcOffset(0, false).local();
            this.fechaEntrega = moment().add(dayFechaEntrega, 'days').utcOffset(0, false).local();
            this.fechaEntregaVisible = true;
        }
        
        this.disableInput()
        if (rol_supervisor) {
            state.bloquearGenerar = true;
            this.setState(state, () => {
                PedidosRequest.ListarSitiosSupervisor()
                    .then(response => {
                        state.arrDrives = response.data.sitio;
                        this.setState(state);
                    })
                    .catch(err => {
                        openNotification(
                            "Ha ocurrido un error al listar los sitios del supervisor.",
                            "Error al listar sitios",
                            false
                        )
                    })
            })
        } else {
            this.setState({ cargando: true }, () => {
                PedidosRequest.ListarArticulosGenerarPedido(this.props.location.state.categoria_id, this.props.location.state.drive_id)
                    .then(response => {
                        if (response.data.length > 0
                            && ["086"].includes(this.props.location.state.segmento_numero)
                            && response.data[0].existencia === null
                        ) {
                            state.columnasOcultables = state.columnasOcultables.filter(x => x.id !== 2 && x.id !== 4);
                            state.columnasOcultablesSelected = state.columnasOcultablesSelected.filter(x => x !== 2 && x !== 4);
                            state.showExistencia = false
                        }

                        if (response.data.length > 0 && ["086"].includes(this.props.location.state.segmento_numero))
                        {
                            response.data.forEach(element => {
                                element.cantidad = 0
                                element.diferencia = 0
                            });
                        }
                        else {
                            response.data.forEach(element => {
                                element.cantidad = element.pedido_sugerido
                                element.diferencia = 0
                            });
                        }
                        
                        state.arrArticulosPedido = response.data
                        state.arrArticulosPedidoCopy = response.data
                        state.cargando = false;
                        this.setState(state);
                    })
                    .catch(err => {
                        openNotification(
                            err?.response?.data?.cuerpo,
                            "Error",
                            false
                        )
                        this.setState({ cargando: false, bloquearGenerar: true },this.props.history.goBack())
                    })
            })
        }
    }

    /**
     * Función que se encarga de evitar que se ingrese texto
     * en select de mostar columnas
     */
    disableInput() {
        const selects = document.getElementsByClassName(`ant-select-search__field`)
        for (let el of selects) {
            el.setAttribute(`maxlength`, 0)
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrArticulosPedidoCopy = state.arrArticulosPedido
        if (value) {
            arrArticulosPedidoCopy = arrArticulosPedidoCopy.filter(obj => {
                return sanitizerTexto(value, obj.codigo_proveedor)
                    || sanitizerTexto(value, obj.descripcion)
            })
        }
        state.arrArticulosPedidoCopy = arrArticulosPedidoCopy
        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se cambia la cantidad de un artículo
     * @param: cantidad. valor del input
     * @param: record. item del input
     */
    onChangeCantArticulo = (cantidad, record) => {
        let state = { ...this.state }
        let cambio = false;
        if (cantidad === "" || cantidad === undefined) cantidad = 0;
        cantidad = Math.round(cantidad)
        state.arrArticulosPedidoCopy.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                if (record.equivalencia) {
                    let resultado = null;
                    // Redondeamos al entero próximo
                    let equivalencia_final = Math.ceil(cantidad / record.equivalencia);
                    // Nos indica de que múltiplo tomar la resta
                    let entero_anterior = equivalencia_final - 1;
                    let limite_superior = record.equivalencia * equivalencia_final
                    let limite_inferior = record.equivalencia * (entero_anterior)
                    // Hacemos la resta del sugerido menos el múltiplo en el que se encuentra
                    // para dejar como residuo lo que no es múltiplo como el caso base
                    let resultado_equivalencia = cantidad - (entero_anterior * record.equivalencia)
                    // si es mayor o igual a la mitad redondeamos
                    if (resultado_equivalencia >= (record.equivalencia / 4)) {
                        resultado = limite_superior
                    } else {
                        resultado = limite_inferior
                    }
                    element.cantidad = resultado
                    element.diferencia = resultado - element.pedido_sugerido
                    cambio = true

                } else {
                    element.cantidad = cantidad
                    element.diferencia = cantidad - element.pedido_sugerido
                }
            }
        })
        state.arrArticulosPedidoCopy.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                element.cantidad = cantidad;  // Actualizar el valor temporal
                element.diferencia = cantidad - element.pedido_sugerido;
            }
        });

        state.arrArticulosPedido.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                element.cantidad = cantidad;  // Actualizar el valor temporal
                element.diferencia = cantidad - element.pedido_sugerido;
            }
        });

        state.arrArticulosPedido.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                if (record.equivalencia) {
                    let resultado = null;
                    // Redondeamos al entero próximo
                    let equivalencia_final = Math.ceil(cantidad / record.equivalencia);
                    // Nos indica de que múltiplo tomar la resta
                    let entero_anterior = equivalencia_final - 1;
                    let limite_superior = record.equivalencia * equivalencia_final
                    let limite_inferior = record.equivalencia * (entero_anterior)
                    // Hacemos la resta del sugerido menos el múltiplo en el que se encuentra
                    // para dejar como residuo lo que no es múltiplo como el caso base
                    let resultado_equivalencia = cantidad - (entero_anterior * record.equivalencia)
                    // si es mayor o igual a la mitad redondeamos
                    if (resultado_equivalencia >= record.equivalencia / 4) {
                        resultado = limite_superior
                    } else {
                        resultado = limite_inferior
                    }
                    element.cantidad = resultado
                    element.diferencia = resultado - element.pedido_sugerido
                    cambio = true
                } else {
                    element.cantidad = cantidad
                    element.diferencia = cantidad - element.pedido_sugerido
                }
            }
        })
        if (cambio) {
            setTimeout(() => { this.setState(state) }, 1500)
        } else {
            this.setState(state)
        }
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.drivesSelected = null;
            state.bloquearGenerar = true;
            state.arrArticulosPedido = [];
            state.arrArticulosPedidoCopy = [];
        } else {
            state.drivesSelected = value;
            state.bloquearGenerar = true;
            state.cargando = true;
            this.setState(state, () => {
                PedidosRequest.ListarArticulosGenerarPedido(this.props.location.state.categoria_id, value)
                    .then(response => {
                        response.data.forEach(element => {
                            element.cantidad = element.pedido_sugerido
                            element.diferencia = 0
                        });
                        state.arrArticulosPedido = response.data
                        state.arrArticulosPedidoCopy = response.data
                        state.cargando = false;
                        state.bloquearGenerar = false;
                        this.setState(state);
                    })
                    .catch(err => {
                        openNotification(
                            err?.response?.data?.cuerpo,
                            "Error al listar artículos",
                            false
                        )
                        this.setState({ cargando: false })
                    })
            })
        }

        this.setState(state)
    }

    /**
     * @param {} :
     * @return {} :
     */
    cambioColumnas = value => {
        let state = { ...this.state };
        // Valores de acuerdo a los IDs dentro del arreglo en el state.
        state.showPedidosTransito = false;
        state.showCantidadPedidos = false;
        state.showExistencia = false;
        state.showVentaDiaria = false;
        state.showExistenciaDias = false;
        state.showPresentacionUDC = false;
        if (value.includes(0)) {
            state.showPedidosTransito = true;
        }
        if (value.includes(1)) {
            state.showCantidadPedidos = true;
        }
        if (value.includes(2)) {
            state.showExistencia = true;
        }
        if (value.includes(3)) {
            state.showVentaDiaria = true;
        }
        if (value.includes(4)) {
            state.showExistenciaDias = true;
        }
        if (value.includes(5)) {
            state.showPresentacionUDC = true;
        }

        state.scroll.x = 750 + (150 * value.length)
        state.columnasOcultablesSelected = value;
        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se confirma edición de usuario
     * @return: nada.
     */
    showConfirm = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro que las cantidades son correctas?</b> Se generará el pedido con las cantidades ingresadas.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-generar-pedido-tabla',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-generar-pedido-tabla',
            },
            onOk: () => {
                this.setState({ cargando: true, bloquearBotones: true }, this.generarPedido)
            },
        });
    }

    /**
     * Función que se ejecuta cuando se confirma generar pedido
     * @return: nada.
     */
    generarPedido = () => {
        let state = { ...this.state }
        let objEnviar = {};
        objEnviar.articulos = state.arrArticulosPedido.filter(item => item.cantidad > 0)
        objEnviar.sitio = state.arrArticulosPedido[0].sitio_id

        objEnviar.fechaEntrega = null
        if (this.props.location.state.categoria_id === 3 || this.props.location.state.categoria_id === 2) 
            objEnviar.fechaEntrega = this.fechaEntrega.format('YYYY-MM-DD')

        let bloqueoHasta;
        if (this.state.segmentoNumero === "086") {
            const finDelDia = new Date();
            finDelDia.setHours(23, 59, 59, 999);
            bloqueoHasta = finDelDia.getTime();
        } 
        else {
            bloqueoHasta = Date.now() + timerBloqueo * 60 * 1000;
        }
        const categoriaId = String(this.props.location.state.categoria_id);

        let categoriasBloquedas = JSON.parse(localStorage.getItem("categoriaBloqueadas")) || {};

        categoriasBloquedas[categoriaId] = bloqueoHasta;
        localStorage.setItem("categoriaBloqueadas", JSON.stringify(categoriasBloquedas));

        if (objEnviar.articulos.length) {
            state.bloquearBotones = true;
            state.cargando = true;
            state.procesado = true;
            state.bloquearGenerar = true;

            localStorage.setItem("bloquearGenerar", "true");
            localStorage.setItem("procesado", "true");
            localStorage.setItem("pedidoEnProceso", "true");
    
            this.setState(state, () => {
                PedidosRequest.GenerarPedido(this.props.location.state.categoria_id, objEnviar)
                .then(response => {
                    this.setState({ bloquearBotones: false, cargando: false, procesado: false })
                    localStorage.removeItem("bloquearGenerar");
                    localStorage.removeItem("procesado");
                    localStorage.removeItem("previousPath");
                    localStorage.removeItem("pedidoEnProceso");
                    this.props.history.goBack()
                    openNotification(
                        response.data.cuerpo,
                        response.data.titulo,
                        true
                    )
                })
                .catch(err => {
                    localStorage.removeItem("bloquearGenerar");
                    localStorage.removeItem("procesado");
                    localStorage.removeItem("previousPath");
                    localStorage.removeItem("pedidoEnProceso");

                    this.setState({ bloquearBotones: false, cargando: false, procesado: false })
                    if(Array.isArray(err.response.data.cuerpo))
                    {
                        const listadoErrores = err.response.data.cuerpo.map(e => `• ${e.MESSAGE}`).join('\n');
                        openNotification(
                            listadoErrores,
                            'Error',
                            false // es error
                        );
                    }
                    else {
                        openNotification(
                            err.response.data.cuerpo,
                            err.response.data.titulo,
                            false
                        )
                    }
                    this.props.history.goBack();
                });
            })
        } else {
            this.setState({ bloquearBotones: false, cargando: false })
            openNotification(
                "Ingrese cantidad en al menos un artículo.",
                "Error al generar pedido",
                false
            )
        }
    }

    /**
     * Función que se ejecuta cuando se confirma generar pedido
     * @return: nada.
     */

    onBlurCantArticulo = (e, record) => {
        const cantidad = parseFloat(e.target.value); // Convertir a número
        let state = { ...this.state };

        // Validar que el valor sea un número (incluyendo 0)
        if (isNaN(cantidad)) {
            return;
        }

        // Obtener los valores de múltiplos, mínimos y máximos
        const multiplos = record.multiplos_pedidos;
        const minimo = record.cantidad_min;
        const maximo = record.cantidad_max;
        const articulo = record.codigo_proveedor;

        // Validar que el valor esté dentro del rango permitido (solo si mínimo y máximo están definidos)
        if (
            ((minimo !== null && minimo !== undefined && cantidad < minimo) ||
            (maximo !== null && maximo !== undefined && cantidad > maximo)) && cantidad !== 0
        ) {
            let mensaje = `Por favor, ingresa un valor para el artículo ${articulo}`;

            // Agregar condición de rango si minimo y/o maximo no son null
            if (minimo !== null || maximo !== null) {
                mensaje += ` que esté entre ${minimo ?? "sin límite inferior"} y ${maximo ?? "sin límite superior"}`;
            }

            // Agregar condición de múltiplo si multiplos no es null
            if (multiplos !== null && multiplos !== undefined) {
                mensaje += ` y que sea un múltiplo de ${multiplos}`;
            }

            mensaje += ".";

            // Mostrar la notificación
            openNotification(mensaje, "Advertencia", false);

            // Restaurar el valor anterior
            this.setState(prevState => ({
                arrArticulosPedido: prevState.arrArticulosPedido.map(item =>
                    item.articulo_id === record.articulo_id ? { ...item, cantidad: item.cantidad_anterior, diferencia: 0 } : item
                ),
                arrArticulosPedidoCopy: prevState.arrArticulosPedidoCopy.map(item =>
                    item.articulo_id === record.articulo_id ? { ...item, cantidad: item.cantidad_anterior, diferencia: 0 } : item
                ),
            }));

            // Enfocar el input
            e.target.focus();
            return;
        }

        // Validar que el valor sea un múltiplo permitido (solo si múltiplos está definido)
        if (
            multiplos !== null &&
            multiplos !== undefined &&
            cantidad !== 0 &&
            cantidad % multiplos !== 0
        ) {
            openNotification(
                `Por favor, ingresa un valor para el artículo ${articulo} que sea un múltiplo de ${multiplos}.`,
                "Advertencia",
                false
            );

            // Restaurar el valor anterior
            this.setState(prevState => ({
                arrArticulosPedido: prevState.arrArticulosPedido.map(item =>
                    item.articulo_id === record.articulo_id ? { ...item, cantidad: item.cantidad_anterior, diferencia: 0 } : item
                ),
                arrArticulosPedidoCopy: prevState.arrArticulosPedidoCopy.map(item =>
                    item.articulo_id === record.articulo_id ? { ...item, cantidad: item.cantidad_anterior, diferencia: 0 } : item
                ),
            }));

            // Enfocar el input
            e.target.focus();
            return;
        }

        // Si el valor es válido, aplicar la lógica de equivalencia (excepto 0)
        let cambio = false;
        state.arrArticulosPedidoCopy.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                if (cantidad !== 0 && record.equivalencia) {
                    let resultado = null;
                    let equivalencia_final = Math.ceil(cantidad / record.equivalencia);
                    let entero_anterior = equivalencia_final - 1;
                    let limite_superior = record.equivalencia * equivalencia_final;
                    let limite_inferior = record.equivalencia * (entero_anterior);
                    let resultado_equivalencia = cantidad - (entero_anterior * record.equivalencia);
                    if (resultado_equivalencia >= (record.equivalencia / 4)) {
                        resultado = limite_superior;
                    } else {
                        resultado = limite_inferior;
                    }
                    element.cantidad = resultado;
                    element.diferencia = resultado - element.pedido_sugerido;
                    cambio = true;
                } else {
                    element.cantidad = cantidad;
                    element.diferencia = cantidad - element.pedido_sugerido;
                }
            }
        });

        state.arrArticulosPedido.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                if (cantidad !== 0 && record.equivalencia) {
                    let resultado = null;
                    let equivalencia_final = Math.ceil(cantidad / record.equivalencia);
                    let entero_anterior = equivalencia_final - 1;
                    let limite_superior = record.equivalencia * equivalencia_final;
                    let limite_inferior = record.equivalencia * (entero_anterior);
                    let resultado_equivalencia = cantidad - (entero_anterior * record.equivalencia);
                    if (resultado_equivalencia >= record.equivalencia / 4) {
                        resultado = limite_superior;
                    } else {
                        resultado = limite_inferior;
                    }
                    element.cantidad = resultado;
                    element.diferencia = resultado - element.pedido_sugerido;
                    cambio = true;
                } else {
                    element.cantidad = cantidad;
                    element.diferencia = cantidad - element.pedido_sugerido;
                }
            }
        });

        // Actualizar el estado
        if (cambio) {
            setTimeout(() => { this.setState(state); }, 1500);
        } else {
            this.setState(state);
        }
    };

    clearPedidoReal() {
        let state = { ...this.state };
        state.arrArticulosPedidoCopy.forEach(articulo => {
            articulo.cantidad = 0;
            articulo.diferencia = 0
        });

        state.showModalConfirm = false;
        this.setState(state);
    }

    handleBeforeUnload = (event) => {
        if (this.state.procesado) { // ejemplo: si estás guardando
            event.preventDefault();
            event.returnValue = "Se está ejecutando un proceso de generación de pedido. Si refrescas o cierras la página, se interrumpirá el proceso.";
        }
        else {
            const previousPath = localStorage.getItem("previousPath");
            if (previousPath) {
                this.props.history.push(previousPath);
            }
        }
    }

    onSalir = () => {
        if (this.state.procesado) {
            this.setState({ showModalSalir: true });
        } else {
            const previousPath = localStorage.getItem("previousPath");
            if (previousPath)
            {
                this.props.history.push(previousPath);
            } else {
                this.props.history.goBack();
            }
        }
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo_proveedor",
                key: "codigo_proveedor",
                width: this.state.tableMeasures.codigoWidth,
                fixed: 'left',
                show: true,
                className: "codigoColumn"
            },
            {
                title: this.state.tableTitles.nombre,
                dataIndex: this.state.tableSources.nombre,
                key: "descripcion",
                width: this.state.tableMeasures.nombreWidth,
                fixed: 'left',
                show: true,
                className: "nombreColumn",
                render: (value, record) => (
                    <Tooltip title={value} placement='top'>{value}</Tooltip>
                )
            },
            {
                title: "UDC",
                dataIndex: "unidad_compra",
                key: "unidad_compra",
                width: this.state.tableMeasures.udcWidth,
                fixed: 'left',
                show: true
            },
            ["Drive"].includes(localStorage.getItem("role")) &&
            {
                title: "Pedido sugerido",
                dataIndex: "pedido_sugerido",
                key: "pedido_sugerido",
                width: this.state.tableMeasures.sugeridoWidth,
                align: 'center',
                show: true
            },
            {
                title: "Pedido real",
                dataIndex: "cantidad",
                key: "cantidad",
                width: this.state.tableMeasures.pedidoRealWidth,
                align: 'center',
                show: true,
                render: (value, record) => (
                    <InputNumber
                        type="number"
                        size={this.state.tableMeasures.inputSize}
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}  
                        maxLength={7}
                        onWheel={(e) => e.target.blur()}
                        onChange={(cantidad) => this.onChangeCantArticulo(cantidad, record)}
                        onBlur={(e) => this.onBlurCantArticulo(e, record)}  
                        onPressEnter={(e) => this.onBlurCantArticulo(e, record)}  
                        value={ record.cantidad }
                    />
                )
            },
            {
                title: "Diferencia",
                dataIndex: "diferencia",
                key: "diferencia",
                width: this.state.tableMeasures.diferenciaWidth,
                align: 'center',
                show: true
            },
            {
                title: "Pedidos en tránsito",
                dataIndex: "pedidos_en_transito",
                key: "pedidos_en_transito",
                width: this.state.tableMeasures.diferenciaWidth,
                align: 'center',
                show: this.state.showPedidosTransito,
            },
            {
                title: "Cant. en pedidos",
                dataIndex: "cantidad_en_pedidos",
                key: "cantidad_en_pedidos",
                width: this.state.tableMeasures.cantidadEnPedidosWidth,
                align: 'center',
                show: this.state.showCantidadPedidos,
            },
            {
                title: "Existencia",
                dataIndex: "existencia",
                key: "existencia",
                width: this.state.tableMeasures.existenciaWidth,
                align: 'center',
                show: this.state.showExistencia,
                render: existencia => (
                    <span>
                        {existencia.toFixed(3)}
                    </span>
                )
            },
            {
                title: "Venta prom. diaria",
                dataIndex: "vent_prom_diaria",
                key: "vent_prom_diaria",
                width: this.state.tableMeasures.ventaPromediaDiariaWidth,
                align: 'center',
                show: this.state.showVentaDiaria,
            },
            {
                title: "Existencia en días",
                dataIndex: "existencia_dias",
                key: "existencia_dias",
                width: this.state.tableMeasures.existenciaEnDiasWidth,
                align: 'center',
                show: this.state.showExistenciaDias,
            },
            {
                title: "Pres. de UDC",
                dataIndex: "presentacion_udc",
                key: "presentacion_udc",
                width: this.state.tableMeasures.presDeUdc,
                align: 'center',
                show: this.state.showPresentacionUDC,
            }
        ]
        let columnasTabla = columnasArticulos.filter(obj => obj.show === true)
        
        return (
            <ResponsiveCard id="ParentSize"
                className='generarPedido'
                title="Módulo generar pedido"
                extra={
                    <div>
                        { this.fechaEntregaVisible === true ? <DatePicker
                                placeholder="Fecha de entrega"
                                value={this.fechaEntrega}
                                format={dateFormat}
                                onChange={(date) => {
                                    this.fechaEntrega = date;
                                    this.setState({});
                                }}
                                disabledDate={(current) => {
                                    return moment(this.minDate) >= current
                                }}
                                style={{ width: '40%', marginRight: '2%' }}
                            />
                            :
                            <></>
                        }
                        <Button
                            id="boton-atras-generar-pedido"
                            className="btnCancelar"
                            key="back"
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                                this.props.history.goBack()
                            }}
                        >
                            Atrás
                        </Button>
                        <Button
                            id="boton-generar-pedido-tabla"
                            type="primary"
                            disabled={this.state.bloquearGenerar}
                            loading={this.state.procesado}
                            onClick={() => {
                                this.showConfirm()
                            }}
                        >
                            Generar pedido
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Nombre + Unidad de medida">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-articulos-generar-pedido"
                                        placeholder="Buscar por Código / Nombre + Unidad de medida"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                            <Col className={localStorage.getItem("role") !== "Supervisor de Operaciones Drive" ? 'display-none' : ''} span={6}>
                                <div className="center">Punto de venta:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione punto de venta">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            { localStorage.getItem("role") === "Barista" ? "" : <Col span={6} className="responsiveHide">
                                <Tooltip placement="top" title="Mostrar columnas de la tabla">
                                    <div className="center">Mostrar columnas: </div>
                                    <Select
                                        allowClear={true}
                                        className='no-text-select'
                                        style={{ width: "100%" }}
                                        notFoundContent="No hay opciones"
                                        placeholder="Seleccionar"
                                        defaultValue={undefined}
                                        showSearch
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        mode="multiple"
                                        onChange={this.cambioColumnas}
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.columnasOcultablesSelected}
                                    >
                                        {
                                            this.state.columnasOcultables.length > 0 &&
                                            this.state.columnasOcultables.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.descripcion}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col> }
                            <Col align="right">
                                <Tooltip placement="top" title="Borrar la cantidad del pedido real">
                                    <Button
                                        icon="delete"
                                        className="btnVerCrearGuardar"
                                        onClick={() => {
                                                let state = { ...this.state }
                                                state.tipo_modal = "Eliminar";
                                                state.showModalConfirm = true;
                                                this.setState(state)
                                            }
                                        }
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row> 
                        <br />
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        >
                            <Table
                                size="small"
                                locale={{ emptyText: 'No se han encontrado resultados.' }}
                                rowKey={(articulos, index) => index}
                                columns={columnasTabla}
                                pagination={false}
                                scroll={this.state.scroll}
                                dataSource={this.state.arrArticulosPedidoCopy}
                                style={{overflow: "auto"}}
                            />
                        </Spin>
                    </div>
                </div>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Eliminar cantidades</p>}
                    onCancel={() => {
                        let state = { ...this.state };
                        state.showModalConfirm = false;
                        this.setState(state);
                    }}
                    centered={ true }
                    visible={ this.state.showModalConfirm }
                    maskClosable={ false }
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.showModalConfirm = false;
                                this.setState(state);
                            }}>
                            Cancelar
                        </Button>,
                        <Button
                            key="submit"
                            className="btnEmbarcar"
                            type="primary"
                            onClick={() => { this.clearPedidoReal() }}
                        >
                            Continuar
                        </Button>
                    ]}
                >
                    <p style={{ textAlign: "center" }}>Se van a eliminar las cantidades del Pedido Real. ¿Desea continuar?</p>
                </Modal>
                <Modal
                    title="Proceso en ejecución"
                    centered
                    visible={this.state.showModalSalir}
                    maskClosable={false}
                    onCancel={() => this.setState({ showModalSalir: false })}
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => this.setState({ showModalSalir: false })}
                        >
                            Cancelar
                        </Button>,
                        <Button
                            key="ok"
                            type="primary"
                            onClick={() => {
                                this.setState({ showModalSalir: false, procesado: false }, () =>
                                    this.props.history.goBack()
                                );
                            }}
                        >
                            Abandonar
                        </Button>,
                    ]}
                >
                    <p style={{ textAlign: "center" }}>
                        Se está ejecutando un proceso de generación de pedido.  
                        Si abandonas la página, se interrumpirá.  
                        ¿Deseas continuar?
                    </p>
                </Modal>
            </ResponsiveCard>
        )
    }
}